import { Component, OnInit } from '@angular/core';
import * as momnet from 'moment'
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  today(date: Date) {
    const fromDate = momnet(date).startOf('day');
    const toDate = momnet(date).endOf('day');
    return ({ fromDate, toDate });
  }
}
